import React, { useState, useEffect, useContext } from "react";
import { NotificationManager } from "react-notifications";
import { Link } from "react-router-dom";
import SmallInput from "../Components/SmallInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import SideLabelInput from "../Components/SideLabelInput";
import useApi from "../Api/Api";
import SalesLayout from "./SalesLayout";
import Button from "../Components/Button";
import { FilterContext } from "../FilterContextProvider";
import StatesList from "../Components/StatesList";
import useAllProducts from "../hooks/useAllProducts";
import { useHistory } from "react-router-dom";

const CreateComps = () => {
  const api = useApi();
  const [errorMessage, setErrorMessage] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const { filterData } = useContext(FilterContext);
  const { allProducts } = useAllProducts(true);
  const [alterProdsObj, setAlterProdsObj] = useState({});
  const history = useHistory();

  let today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();

  today = yyyy + "-" + mm + "-" + dd;

  const [event, setEvent] = useState({
    artist_id: filterData.artist_id,
    comment: "",
    date: today,
    name: "",
    reporting_type: "comp",
    party: "",
  });

  allProducts.forEach((product) => {
    product.product_size = product.size?.name || product.size_other;
    product.band_comp_quantity = 0;
    product.ctm_comp = 0;
    product.management_comp = 0;
  });

  const productNames = [
    ...new Set(
      allProducts.map(
        (product) =>
          `${product.name}*${product.category?.index}*%${product.image_url}`
      )
    ),
  ];

  const productSizes = [
    ...new Set(
      allProducts.map(
        (product) => `${product.product_size}*${product.size?.index}`
      )
    ),
  ];

  productNames
    .sort((a, b) => a.split("*")[0].localeCompare(b.split("*")[0]))
    .sort((a, b) => a.split("*")[1].localeCompare(b.split("*")[1]));

  productSizes.sort((a, b) => a.split("*")[1].localeCompare(b.split("*")[1]));

  const prodNamesArray = productNames.map(function (value) {
    return {
      name: value.split("*")[0],
      category_index: value.split("*")[1],
      image: value.split("%")[1],
    };
  });

  const prodSizesArray = productSizes.map(function (value) {
    return {
      name: value.split("*")[0],
      size_index: value.split("*")[1],
    };
  });

  const compOptions = [
    {
      label: "Band Comp",
      value: "band_comp_quantity",
    },
    {
      label: "Management Comp",
      value: "management_comp",
    },
    {
      label: "TM Comp",
      value: "ctm_comp",
    },
  ];

  const handleSelect = (option, name) => {
    if (name.name === "party") {
      setAlterProdsObj({});
      setEvent({
        ...event,
        [name.name]: option.value,
        venue_rep_name: option.label,
      });
    } else {
      setEvent({
        ...event,
        [name.name]: option.value,
      });
    }
  };

  const stateOptions = StatesList.map((state) => ({
    label: state.name,
    value: state.abbreviation,
  }));

  const [currentPage, setCurrentPage] = useState(1);

  const [frontEndPagy, setFrontEndPagy] = useState({
    count: 0,
    from: 1,
    last: 1,
    next: 2,
    page: 1,
    prev: 0,
    to: 15,
  });

  const handlePageChange = (e) => {
    setCurrentPage(e.target.value);
  };

  useEffect(() => {
    if (currentPage * 15 < prodNamesArray.length) {
      setFrontEndPagy({
        count: prodNamesArray.length,
        from: (currentPage - 1) * 15 + 1,
        last: Math.ceil(prodNamesArray.length / 15),
        next: parseInt(currentPage) + 1,
        page: parseInt(currentPage),
        prev: currentPage - 1,
        to: currentPage * 15,
      });
    } else {
      setFrontEndPagy({
        count: prodNamesArray.length,
        from: (currentPage - 1) * 15 + 1,
        last: Math.ceil(prodNamesArray.length / 15),
        next: null,
        page: parseInt(currentPage),
        prev: currentPage - 1,
        to: prodNamesArray.length,
      });
    }
  }, [prodNamesArray.length, currentPage]);

  const handleEventChange = ({ target: { id, value } }) => {
    setEvent({
      ...event,
      [id]: value,
    });
  };

  const handleInputChange = ({ target: { name, value } }, productToRender) => {
    const prodToAlter = allProducts.find((one) =>
      name !== "null"
        ? one.name === productToRender.name && one.product_size === name
        : one.name === productToRender.name
    );
    setAlterProdsObj({
      ...alterProdsObj,
      [prodToAlter.id]: {
        ...prodToAlter,
        [event.party]: value,
        product_id: prodToAlter.id,
        product_name: prodToAlter.name,
        product_category: prodToAlter.category.name,
        price: prodToAlter.retail_price,
        date: event.date,
        total: parseInt(value) * prodToAlter.cost,
        reporting_type: "comp",
      },
    });
  };

  const revert = () => {
    let message =
      "Are you sure you want to revert? All unsaved changes will be lost.";
    const check = window.confirm(message);
    if (check) {
      setAlterProdsObj({});
    }
  };

  const handleUpdateSales = (e) => {
    setIsFetching(true);
    e.preventDefault();
    Object.values(alterProdsObj).forEach((one) => {
      delete one.id;
    });
    api
      .post(`/events/`, {
        event: {
          ...event,
          comment: `$${grossAll}`,
          sales_attributes: Object.values(alterProdsObj).map((each) => each),
        },
      })
      .then(() => {
        NotificationManager.success(
          "Sales successfully updated",
          "Success",
          2000
        );
        history.push("/sales/comps/list");
        setErrorMessage(false);
      })
      .catch((error) => {
        setErrorMessage(error.response.data);
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  const prodNamesToRender = prodNamesArray.slice(
    frontEndPagy.from - 1,
    frontEndPagy.to
  );

  Object.values(alterProdsObj).forEach(
    (one) =>
      (one.total =
        (parseInt(one.band_comp_quantity) +
          parseInt(one.ctm_comp) +
          parseInt(one.management_comp)) *
        one.cost)
  );

  const grossAll = Object.values(alterProdsObj).reduce((a, b) => {
    return a + b.total;
  }, 0);

  const renderTable = () => {
    return (
      <table className="w-full">
        <thead className="text-xs font-light">
          <tr className="text-left border-b-2 h-11 text-center">
            <td className="w-1/4 text-left pl-6">PRODUCT</td>
            <td className="w-1/8 text-left pl-3">IMAGE</td>
            {prodSizesArray.map((prodSize) => {
              return (
                <td key={prodSize.name} className="w-thinner">
                  {prodSize.name !== "null" ? prodSize.name : "No size"}
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {prodNamesToRender.map((prod, i) => {
            const prodName =
              Object.values(alterProdsObj).find(
                (one) => one.name === prod.name
              ) || prod;
            return (
              <tr
                key={prodName.name}
                className={
                  Object.values(alterProdsObj).find(
                    (one) => one.name === prodName.name
                  )
                    ? "bg-yellow-50 border-t text-xs h-11 text-center"
                    : "border-t text-xs h-11 text-center"
                }
              >
                <td className="pl-6 text-left text-sm">{prodName.name}</td>
                <td className="text-center">
                  {prodName.image && (
                    <img
                      src={prodName.image}
                      alt="Product"
                      className="h-16 rounded-md"
                    />
                  )}
                </td>
                {prodSizesArray.map((prodSize) => {
                  const product =
                    Object.values(alterProdsObj).find((one) =>
                      prodSize.name !== "null"
                        ? one.name === prodName.name &&
                          one.product_size === prodSize.name
                        : one.name === prodName.name &&
                          one.product_size === null
                    ) || prod;
                  return (
                    <td key={prodSize.name}>
                      <SmallInput
                        name={prodSize.name}
                        id={`${prodSize}_${i}`}
                        onChange={(e) => handleInputChange(e, product)}
                        value={product?.[event.party] ?? ""}
                        disabled={
                          prodSize.name !== "null"
                            ? !allProducts.find(
                                (one) =>
                                  one.name === product.name &&
                                  one.product_size === prodSize.name
                              )
                            : !allProducts.find(
                                (one) =>
                                  one.name === product.name &&
                                  one.product_size === null
                              )
                        }
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <SalesLayout>
      <div className="mt-10 mx-8 py-5 px-12 text-black bg-white rounded-lg border">
        <div className="font-medium -mx-2 text-black text-sm">
          <Link to="/sales/comps/list">
            <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to comps
            list
          </Link>
        </div>
        <div className="py-2 -mx-2 text-2xl font-medium">Add New Comps</div>
        <div className="my-4 text-sm">
          <div className="flex flex-col">
            <div className="flex mb-4">
              <div className="w-1/4 mr-8">
                <div className="flex">
                  <div className="flex w-1/3 items-center">
                    <label htmlFor="date" className="text-xs">
                      Date
                    </label>
                  </div>
                  <input
                    value={event.date ?? ""}
                    type="date"
                    id="date"
                    name="date"
                    className="text-xs h-9 pl-2 ml-5 font-light rounded-md border w-full justify-self-end"
                    onChange={handleEventChange}
                    required
                  ></input>
                </div>
                {errorMessage?.errors?.date && (
                  <div className="text-red-500 pb-2">
                    {errorMessage.errors.date}
                  </div>
                )}
              </div>
              <div className="w-1/4">
                <SideLabelInput
                  id="total_cost"
                  name="total_cost"
                  label="Total Cost"
                  value={`$ ${grossAll}` ?? ""}
                  onChange={handleEventChange}
                  disabled
                />
              </div>
            </div>
            <div className="flex text-xs mb-4">
              <div className="w-1/4 mr-8">
                <SideLabelInput
                  id="name"
                  name="name"
                  label="Venue / Place"
                  value={event.name}
                  onChange={handleEventChange}
                  disabled={isFetching}
                  required
                />
                {errorMessage?.errors?.name && (
                  <div className="text-red-500 pb-2">
                    {errorMessage.errors.name}
                  </div>
                )}
              </div>
              <div className="w-1/4 mr-8">
                <SideLabelInput
                  id="notes"
                  name="notes"
                  label="For What"
                  value={event.notes}
                  onChange={handleEventChange}
                  disabled={isFetching}
                />
              </div>
              <div
                className={
                  event.party
                    ? "w-1/4"
                    : "w-1/4 border-2 p-1 -mt-2 border-blue-500"
                }
              >
                <div className="flex">
                  <div className="flex items-center w-1/3">
                    <label htmlFor="comp_filter" className="text-xs">
                      For Whom
                    </label>
                  </div>
                  <div className="w-full ml-5">
                    <Select
                      id="party"
                      name="party"
                      placeholder="Select party"
                      options={compOptions}
                      onChange={(option, name) => handleSelect(option, name)}
                      className="text-xs font-light font-light rounded-md justify-self-end"
                      value={compOptions?.filter(
                        (each) => each.value === event.party
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex text-xs">
              <div className="w-1/4 mr-8">
                <SideLabelInput
                  id="city"
                  name="city"
                  label="City"
                  value={event.city}
                  onChange={handleEventChange}
                  disabled={isFetching}
                  required
                />
              </div>
              <div className="w-1/4 mr-8">
                <div className="flex">
                  <div className="flex items-center w-1/3">
                    <label htmlFor="state" className="text-xs">
                      State
                    </label>
                  </div>
                  <div className="w-full ml-5">
                    <Select
                      id="state"
                      name="state"
                      placeholder="Select state"
                      options={stateOptions}
                      onChange={(option, name) => handleSelect(option, name)}
                      className="text-xs font-light font-light rounded-md justify-self-end"
                      value={stateOptions?.filter(
                        (each) => each.value === event.state
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="w-1/4">
                <SideLabelInput
                  id="zip_code"
                  name="zip_code"
                  label="Zip Code"
                  value={event.zip_code}
                  onChange={handleEventChange}
                  disabled={isFetching}
                />
              </div>
            </div>
          </div>
        </div>
        {prodNamesArray.length > 0 ? (
          <div className="-mx-12">
            {event.party ? (
              <form className="-mb-4">{renderTable()}</form>
            ) : (
              <div className="m-12">
                Please select "For Whom" before continuing
              </div>
            )}
            {Object.keys(alterProdsObj).length > 0 && (
              <span className="flex justify-center mt-16">
                <span className="mr-2">
                  <Button
                    className="button button-white"
                    onClick={revert}
                    text="Revert"
                    disabled={isFetching}
                  ></Button>
                </span>
                <Button
                  className="button"
                  onClick={handleUpdateSales}
                  text="Update"
                  disabled={isFetching}
                ></Button>
              </span>
            )}
            {errorMessage?.error && (
              <div className="text-red-500 flex justify-center my-4">
                {errorMessage.error}
              </div>
            )}
          </div>
        ) : (
          <div className="mx-4 my-12">
            No products have been added for this artist yet.
          </div>
        )}
      </div>
      {productNames.length > 0 && event.party && (
        <footer className="text-sm mt-4 mx-8 flex justify-between">
          <div className="ml-1 mr-8">
            Showing <span className="font-bold">{frontEndPagy.from} </span>to
            <span className="font-bold"> {frontEndPagy.to} </span>of
            <span className="font-bold"> {frontEndPagy.count} </span>results
          </div>
          <div className="mr-8">
            Page {frontEndPagy.page} of {frontEndPagy.last}
          </div>
          <div className="flex -mt-2">
            <span>
              <Button
                value={1}
                className={
                  frontEndPagy.page === 1
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="First"
                disabled={frontEndPagy.page === 1}
              ></Button>
            </span>
            <span className="mx-1">
              <Button
                value={frontEndPagy.prev}
                className={
                  !frontEndPagy.prev
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Prev"
                disabled={!frontEndPagy.prev}
              ></Button>
            </span>
            <span>
              <Button
                value={frontEndPagy.next}
                className={
                  !frontEndPagy.next
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Next"
                disabled={!frontEndPagy.next}
              ></Button>
            </span>
            <span className="ml-1">
              <Button
                value={frontEndPagy.last}
                className={
                  frontEndPagy.page === frontEndPagy.last
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Last"
                disabled={frontEndPagy.page === frontEndPagy.last}
              ></Button>
            </span>
          </div>
        </footer>
      )}
    </SalesLayout>
  );
};

export default CreateComps;
